import React, { memo, forwardRef } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../index'
import { util } from '../../../util'

const Alert = (
    {
        show,
        closeAlertHandler,
        description,
        title,
        type,
        variant = 'outlined',
        renderIcon = util.ReportProblemIcon,
        className,
        color,
        renderRoute,
    },
    ref
) => {
    if (!show) {
        return null
    }

    return (
        <div
            ref={ref}
            data-testid={'alert'}
            className={util.joinClasses(
                'alert',
                type,
                variant,
                color && `color-${color}`,
                className
            )}
        >
            <Icon
                className={'alert__svg-icon'}
                color={variant !== 'fill' ? type : null}
                size={'sm'}
                renderIcon={renderIcon}
            />
            <div className={'alert__content'}>
                <p className={'alert__content--title'}>{title}</p>
                {description && <p className={'alert__content--description'}>{description}</p>}
            </div>
            {!!renderRoute && <div className={'alert__render-link'}>{renderRoute()}</div>}
            {closeAlertHandler ? (
                <Icon
                    pointer={true}
                    className={'alert__close-icon'}
                    size={'sm'}
                    onClick={closeAlertHandler}
                    renderIcon={util.CloseIcon}
                />
            ) : null}
        </div>
    )
}

const AlertComponent = forwardRef(Alert)

AlertComponent.propTypes = {
    /**@param {Boolean} -> if show is true then alert components will be displayed */
    show: PropTypes.bool,

    /* closeAlertHandler {CallableFunction} -> Callback to close alert. */
    closeAlertHandler: PropTypes.func,

    /* description {String} -> Alert detail description */
    description: PropTypes.string,

    /* title {String} -> Alert title */
    title: PropTypes.string,
    color: PropTypes.oneOf(['teal']),
    type: PropTypes.oneOf(['warning', 'danger', 'success', 'primary']),
    variant: PropTypes.oneOf(['fill', 'outlined']),
}

export default memo(AlertComponent)
